import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiArrowRight } from 'react-icons/fi';

const QuickSummary = () => {
  return (
    <section className="py-16 bg-vintage-white border-t border-warm-stone/20">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="border-l-4 border-olive-grove pl-6 md:pl-8 py-2 mb-10"
        >
          <h2 className="text-sm font-bold uppercase tracking-widest text-olive-grove mb-4">
            Quick Summary for Couples
          </h2>
          <p className="text-lg text-deep-charcoal/90 leading-relaxed font-light">
            Padua Weddings is best for couples who want a romantic Southern California wedding venue with historic Spanish Revival architecture, a foothill setting, ceremony and reception spaces, in-house catering, coordination support, DJ services, planning guidance, and a refined guest experience that feels elevated without feeling overly formal or impersonal.
          </p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="flex flex-col sm:flex-row items-center gap-6 pt-4 border-t border-warm-stone/20"
        >
          <p className="text-sm text-deep-charcoal/60 font-light italic text-center sm:text-left">
            Want to see how the setting feels in person? Schedule a private tour and walk the ceremony, reception, and guest flow with our team.
          </p>
          <a 
            href="https://tour.paduaweddings.com" 
            className="flex-shrink-0 inline-flex items-center text-sm font-medium text-estate-bronze uppercase tracking-widest hover:text-olive-grove transition-colors group"
          >
            Schedule a Private Tour
            <SafeIcon icon={FiArrowRight} className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default QuickSummary;